<template>
    <div class="group_buy_div" v-if="group_buy_info.id">
        <div class="product_div">
            <a :href="group_buy_info.html_url">
                <img style="width: 100%"
                     :src="group_buy_info.picture_url">
            </a>

        </div>
        <div class="buy_div">
            <div class="title">
                {{group_buy_info.title}}
            </div>
            <div class="price">
                <ul class="price-infos">
                    <li class="price-info" style="border-right: 2px solid #eee;">
                        <div>原价</div>
                        <div style="color: black">{{group_buy_info.item_price}}</div>
                    </li>
                    <li class="price-info" style="border-right: 2px solid #eee;">
                        <div>折扣</div>
                        <div style="color: rgb(89, 207, 74)">
                            {{(group_buy_info.price/group_buy_info.item_price*10).toFixed(1)}}
                        </div>
                    </li>
                    <li class="price-info">
                        <div>为您节省</div>
                        <div style="color: rgb(89, 207, 74)">{{group_buy_info.item_price - group_buy_info.price}}</div>
                    </li>
                </ul>
            </div>
            <div class="buy">
                <div style="height: 30px;background-color: #E0FCBD">

                </div>
                <div style="height: 30px;background-color: #A3F118;">

                </div>
                <div style="position: absolute;top:13px;left:106px;font-size: 24px">
                    ￥{{group_buy_info.price}}
                </div>
                <el-button @click="to_buy" :disabled="countdown=='已结束'"
                           style="position: absolute;top:15px;left:190px;color: black; background-color: #E5D532;padding: 5px 20px 5px 20px;border-radius: 10px"
                           type="warning" plain>抢购
                </el-button>
                <!--<a style="position: absolute;top:15px;left:190px;background-color: #E5D532;padding: 5px 20px 5px 20px;border-radius: 10px">抢购</a>-->


            </div>
            <div class="remain_time">
                <span v-if="countdown!=='已结束'">剩余时间</span>
                <span style="background-color: #E6E6C4;padding: 5px;border-radius: 5px">{{countdown}}</span>
            </div>
            <div class="buy_number">
                {{group_buy_info.paid_number}}人已购买
            </div>
            <div class="success">
                <div style="font-size: 24px" v-if="group_buy_info.min_number>group_buy_info.paid_number">
                    正在抢购中...
                </div>
                 <div style="font-size: 24px" v-else>
                    <img width="30px" height="30px" src="@/assets/img/done.png"/>团购成功
                </div>
                <div>
                    可继续购买
                </div>
            </div>
            <div class="number">
                <sapn v-if="group_buy_info.min_number>group_buy_info.paid_number">还差{{group_buy_info.min_number - group_buy_info.paid_number}}人</sapn><sapn v-else>已</sapn>达到最低团购人数：{{group_buy_info.min_number}}人
            </div>

        </div>
        <el-dialog :modal-append-to-body='false'
                   :visible.sync="dialogVisible"
                   width="30%">
            <ul class="nav_title_ul" style="margin-top: -40px">
                <li class="nav_title_li"
                    :class="nav_title==='购买' ? 'active_nav' : ''"
                    @click="tab_nav('购买')"
                >
                    购买
                </li>
                <li class="nav_title_li"
                    :class="nav_title==='充值' ? 'active_nav' : ''"
                    @click="tab_nav('充值')"
                >
                    充值
                </li>
            </ul>
            <div class="stuff_div">
                <keep-alive>
                    <component :is="stuff_component_dict[nav_title]" :data="group_buy_info"
                               :type="'ujoyer.group.buy'"
                               :all_need_count="group_buy_info.price * 100" :recharge_amount="group_buy_info.price"></component>
                </keep-alive>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import groupBuyApi from '@/api/group_buy/group_buy.js'
    import Expense from '@/components/pay_page/expense.vue'
    import Pay from '@/components/pay_page/pay.vue'


    export default {
        name: "group_buy",
        data() {
            return {
                group_buy_info: {},
                countdown: '',
                nav_title: '购买',
                dialogVisible: false,
                stuff_component_dict: {
                    '购买': 'Expense',
                    '充值': 'Pay'
                },
            }
        },
        components: {
            Expense,
            Pay
        },
        methods: {
            dateFtt(fmt, date) { //author: meizz
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    "S": date.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            },
            get_countdown() {
                var startTime = this.dateFtt("yyyyMMddhhmmss", new Date());
                var endTime = this.group_buy_info.full_end_time;
                if (startTime.length < 14 || endTime.length < 14) {
                    alert('时间格式不正确');
                }
                if (parseInt(startTime) >= parseInt(endTime)) {
                    this.countdown = '已结束'
                } else {
                    var startArr = [startTime.substring(0, 4), startTime.substring(4, 6), startTime.substring(6, 8), startTime.substring(8, 10), startTime.substring(10, 12), startTime.substring(12, 14)];//切分开始时间为数组
                    var endArr = [endTime.substring(0, 4), endTime.substring(4, 6), endTime.substring(6, 8), endTime.substring(8, 10), endTime.substring(10, 12), endTime.substring(12, 14)];//切分结束时间为数组
                    var dateStart = new Date(startArr[0], startArr[1], startArr[2], startArr[3], startArr[4], startArr[5]);//采用new Date(yyyy,mth,dd,hh,mm,ss);创建方式分别传入年月日时分秒
                    var dateEnd = new Date(endArr[0], endArr[1], endArr[2], endArr[3], endArr[4], endArr[5]);
                    var dateInterval = dateEnd.getTime() - dateStart.getTime() //获取时间差毫秒
                    //计算出相差天数
                    var days = Math.floor(dateInterval / (24 * 60 * 60 * 1000));

                    //计算小时数
                    var hourLevel = dateInterval % (24 * 60 * 60 * 1000);
                    var hours = Math.floor(hourLevel / (60 * 60 * 1000))
                    //计算分钟数
                    var minutesLevel = hourLevel % (60 * 60 * 1000);
                    var minutes = Math.floor(minutesLevel / (60 * 1000));
                    //计算秒数
                    var seconds = Math.round((minutesLevel % (60 * 1000)) / 1000);
                    // console.log("时间差是: " + days + "天, " + hours + "小时, " + minutes + "分钟, " + seconds + "秒")
                    this.countdown = days + "天" + hours + "时" + minutes + "分" + seconds + "秒"
                }

            },
            tab_nav(nav_title) {
                this.nav_title = nav_title
            },
            to_buy() {
                groupBuyApi.validate_group_buy_access(this.$route.params.id).then(res => {
                    if (res.data.code == 'success') {
                        this.dialogVisible = true
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
            }
        },

        mounted() {
            groupBuyApi.get_group_buy_info(this.$route.params.id).then(res => {
                this.group_buy_info = res.data
                setInterval(this.get_countdown, 1000);
            })

        }
    }
</script>

<style scoped>
    .group_buy_div {
        width: 1170px;
        height: 500px;
        background-color: white;
        margin: 0 auto;
        margin-bottom: 20px;
    }

    .product_div {
        height: 100%;
        /*background-color: red;*/
        width: 70%;
        float: left;
    }

    .buy_div {
        height: 100%;
        /*background-color: blue;*/
        padding: 0 20px;
        width: 30%;
        float: right;
    }

    .title {
        padding: 10px 0;
        min-height: 130px;
    }

    .price-infos {
        /*margin-top: 28px;*/
        padding: 10px;
        border-top: 1px solid #E5E5E5;
        font-size: 0;
    }

    .price-info {
        display: inline-block;
        vertical-align: top;
        width: 33%;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        color: #999;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .buy {
        height: 60px;
        position: relative;
        /*background-color: #E0FCBD;*/
    }

    .remain_time {
        padding: 20px 5px 20px 5px;
        border-bottom: 1px solid #E5E5E5;
    }

    .buy_number {
        color: #C7A68C;
        padding: 20px 5px 20px 5px;
        font-size: 24px;
        text-align: center;
    }

    .success {
        text-align: center;
    }

    .number {
        padding: 10px;
        text-align: center;
    }

    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

</style>